package com.eladfinish.bible.contest.screens.search.usecases.specialSearch

import com.eladfinish.bible.contest.constants.SharedPrefsConstants
import com.eladfinish.bible.contest.constants.StringConstants.MAKAF
import com.eladfinish.bible.contest.constants.StringConstants.REGEX_SPACE
import com.eladfinish.bible.contest.constants.StringConstants.Regex.OTIOT_1_TO_3
import com.eladfinish.bible.contest.domain.BooksRepository
import com.eladfinish.bible.contest.extensions.formatWithCommas
import com.eladfinish.bible.contest.extensions.matches
import com.eladfinish.bible.contest.extensions.replaceRegex
import com.eladfinish.bible.contest.extensions.splitByRegex
import com.eladfinish.bible.contest.screens.browse.usecases.chumash.GetParashaContentUseCase
import com.eladfinish.bible.contest.screens.search.model.ChapterDetails
import com.eladfinish.bible.contest.utils.GetParashotUseCase
import com.eladfinish.bible.contest.utils.removeWhitespacesAndParshiot
import com.russhwolf.settings.Settings

/**
 * Developed by
 * @author Elad Finish
 */

class WordsPerParashot(
    private val getParashaContentUseCase: GetParashaContentUseCase,
    private val getParashotUseCase: GetParashotUseCase,
    private val settings: Settings,
) : SpecialSearch {

    private val sb = StringBuilder()

    override fun process(chapterDetails: ChapterDetails) = Unit

    override fun isOnlyTorah(): Boolean = true

    override fun getSummary(): String {
        statisticsOfWords()
        return sb.toString()
    }

    private fun statisticsOfWords() {
        sb.append("דו\"ח מספר המילים בפרשות התורה\n\n")
        sb.append("שם הפרשה | סה\"כ מילים\n")

        BooksRepository.chumashim.forEachIndexed { i, chumash ->
            val parashot = getParashotUseCase.parseParashot(bookNumber = i + 1)
            sb.append("\nחומש $chumash:\n")
            var chumashTotalWords = 0

            for (j in 0 until parashot.size) {
                val parashaName = parashot.parashotNames[j]
                val source = parashot.parashotSources[j]
                val parashaContent = getParashaContentUseCase(
                    input = source,
                    bookIndex = i + 1,
                    onlyQri = settings.getBoolean(SharedPrefsConstants.ONLY_QRI_SWITCH, true),
                )

                val wordCount = countWordsInParasha(parashaContent)
                sb.append(parashaName).append(" | ").append(wordCount.formatWithCommas()).append("\n")

                if (!parashaName.contains(" - ")) {
                    chumashTotalWords += wordCount
                }
            }
            sb.append("סה\"כ חומש $chumash | ").append(chumashTotalWords.formatWithCommas()).append("\n")
        }
    }

    private fun countWordsInParasha(parashaContent: String): Int {
        if (parashaContent.isBlank()) return 0

        return parashaContent
            .trim()
            .removeWhitespacesAndParshiot()
            .replaceRegex(
                regex = "$MAKAF",
                replacement = "$MAKAF ",
            )
            .splitByRegex(REGEX_SPACE)
            .filterNot {
                it.matches(OTIOT_1_TO_3)
            }
            .filterNot {
                it.equals(other = "Chapter", ignoreCase = true)
            }
            .count()
    }

}
